/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { TiPencil } from "react-icons/ti";
import { useDispatch } from "react-redux";
import t from "../../../Common/utils/translation/translator";
import EditAxisPopup from "./EditAxisPopup";

import { setEditingAxis } from "../../../Retrofit/store/slices/retrofit";

const DevicesHeaderFiltersRecap = React.memo(({ axis }) => {
  const items = [
    {
      filterName: t("msizer.ui.nominal_torque"),
      filterValue: axis.configFilters?.applicationDataFilter?.nominalTorque?.toString(),
      resultValue: axis.bundle?.bundleData?.nominalTorque?.toString(),
      unit: t("msizer.ui.unit.nm")
    },
    {
      filterName: t("msizer.ui.nominal_speed"),
      filterValue: axis.configFilters?.applicationDataFilter?.nominalSpeed?.toString(),
      resultValue: axis.bundle?.bundleData?.nominalSpeed?.toString(),
      unit: t("msizer.ui.unit.rpm")
    },
    {
      filterName: t("msizer.ui.load_inertia"),
      filterValue: axis.configFilters?.applicationDataFilter?.loadInertia?.toString(),
      resultValue: axis.bundle?.bundleData?.inertia?.toString(),
      unit: t("msizer.ui.unit.kg_cm_squared")
    },
    {
      filterName: t("msizer.ui.max_length"),
      filterValue: axis.configFilters?.applicationDataFilter?.maxLength?.toString(),
      resultValue: axis.bundle?.bundleData?.length?.toString(),
      unit: t("msizer.ui.unit.mm")
    }
  ];

  const [editAxisPopupOpened, setEditAxisPopupOpened] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setEditingAxis(editAxisPopupOpened));
  }, [editAxisPopupOpened]);
  return (
    <>
      <div className="flex max-w-full space-x-1 py-2 px-4 justify-between border-r border-solid border-gray-200 select-step-header overflow-x-auto">
        <div className="flex flex-col">
          <div className="flex pl-2">
            <div className="w-24" />
            {items.map((item) => (
              // eslint-disable-next-line react/no-array-index-key
              // <AxisFiltersRecapItem key={index} {...item} />
              <div className="flex w-28 flex-col text-xs print:text-xxs text-gray-500">
                <span className="underline underline-gray-500">{item.filterName}</span>
              </div>
            ))}
          </div>

          <div
            onClick={() => setEditAxisPopupOpened(true)}
            className="flex pl-2 rounded-full border-transparent hover:shadow-secondary hover:bg-white hover:drop-shadow"
          >
            <div className="flex w-24 items-center space-x-1 text-xs print:text-xxs text-gray-500 italic">
              <span>{t("msizer.ui.select.input")}</span>
              <TiPencil className="text-secondary cursor-pointer print:hidden" />
            </div>
            {items.map((item) => (
              <div className="flex w-28 flex-col text-xs print:text-xxs text-gray-500">
                <span className="w-max">
                  <div>
                    <span className="font-bold">
                      {item.filterValue % 1 === 0 ? item.filterValue : Number(item.filterValue).toFixed(2) || "--"}
                    </span>
                    <span> {item.unit}</span>
                  </div>
                </span>
              </div>
            ))}
          </div>

          <div className="flex pl-2">
            <div className="flex w-24 flex-col text-xs print:text-xxs text-gray-500 italic">
              {t("msizer.ui.select.output")}
            </div>
            {items.map((item) => (
              <div className="flex w-28 flex-col text-xs print:text-xxs text-gray-500">
                <span className="w-max">
                  <div>
                    <span>{Number(parseFloat(item.resultValue).toFixed(2)) || "--"}</span>
                    <span> {item.unit}</span>
                  </div>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <EditAxisPopup
        opened={editAxisPopupOpened}
        axisId={axis.id}
        axis={axis}
        setEditAxisPopupOpened={setEditAxisPopupOpened}
      />
    </>
  );
});

DevicesHeaderFiltersRecap.propTypes = {
  axis: PropTypes.any.isRequired
};

export default DevicesHeaderFiltersRecap;
